import { sensorsInit } from '@fs/utils'
import Vue from 'vue'

export default function () {
    sensorsInit({
        Vue2: Vue,
        env: process.env.VUE_APP_ENV,
        initOptions: {
            show_log: ['dev', 'sit'].includes(process.env.VUE_APP_ENV), // 是否打开log
            is_track_single_page: false,
            AutoTrack: false,
        },
    })
}

// 同花顺国际版埋点
export const initThsI18nWebLog = userId => {
    sessionStorage.setItem('thsI18nUserId', userId)
    window.weblog.setConfig({ appKey: '2ef263507a', domain: 'cbasspider.hithink.sg', userId })
    return ({ id = '', action = 'click' } = {}) => window.weblog.report({ id, action })
}
